// ./src/lib/Storage.js

export default {
  /**
   * retrieves data from storage by key
   *
   * @param {string} key
   */
  get(key) {
    return localStorage.getItem(key);
  },

  /**
   * saves data to storage by key
   *
   * @param {string} key
   * @param {object} value
   */
  set(key, value) {
    localStorage.setItem(key, value);
  },

  remove(key) {
    localStorage.removeItem(key);
  },
};
